import {
  SUCCESS_GET_DATA_TRANSACTIONS,
  SUCCESS_GET_DATA_SHIFTCLOSURES,
  SUCCESS_GET_DATA_RCOFHISTORY,
  CHANGE_PAGE,
  CHANGE_LOADING,
  SET_TRANSACTION_TABLE,
  SET_SHIFT_CLOSURES_TABLE,
  SET_RCOF_HISTORY_TABLE,
  ERROR_GET_DATA,
  SET_FILTER,
  REMOVE_FILTERS,
  SET_QUERY_FILE,
  CLOSE_SESION,
  SET_MAX_PER_PAGE
} from "../../types";

export default (state, action) => {
  switch (action.type) {
    case SUCCESS_GET_DATA_TRANSACTIONS:
      /* localStorage.setItem("transactionTable", true);
      localStorage.setItem("shiftClosuresTable", false); */
      return {
        ...state,
        data: action.payload.transactions,
        totalRows: action.payload.pageInfo.total,
        totalPages: Math.ceil(action.payload.pageInfo.total / state.maxPerPage),
        loading: false,
        transactionTable: true,
        shiftClosuresTable: false,
        error: false,
        errorMessage: "",
      };
    case SUCCESS_GET_DATA_SHIFTCLOSURES:
      /* localStorage.setItem("transactionTable", false);
      localStorage.setItem("shiftClosuresTable", true); */
      return {
        ...state,
        data: action.payload.shiftsClosure,
        totalRows: action.payload.pageInfo.total,
        totalPages: Math.round(
          action.payload.pageInfo.total / state.maxPerPage
        ),
        loading: false,
        shiftClosuresTable: true,
        transactionTable: false,
        error: false,
        errorMessage: "",
      };
    case SUCCESS_GET_DATA_RCOFHISTORY:
      /* localStorage.setItem("transactionTable", false);
      localStorage.setItem("shiftClosuresTable", true); */
      return {
        ...state,
        data: action.payload.transactions,
        totalRows: action.payload.pageInfo.total,
        totalPages: Math.round(
          action.payload.pageInfo.total / state.maxPerPage
        ),
        loading: false,
        rcofHistoryTable: true,
        transactionTable: false,
        error: false,
        errorMessage: "",
      };
    case ERROR_GET_DATA:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        loading: false,
      };
    case CHANGE_PAGE:
      return {
        ...state,
        currentPage: action.payload,
        loading: true,
      };
    case CHANGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_TRANSACTION_TABLE:
      return {
        ...state,
        currentPage: 1,
        loading: true,
      };
    case SET_SHIFT_CLOSURES_TABLE:
      return {
        ...state,
        currentPage: 1,
        loading: true,
      };
    case SET_RCOF_HISTORY_TABLE:
      return {
        ...state,
        currentPage: 1,
        loading: true,
      };
    case SET_FILTER:
      const filterPersist = {
        ...state.filters,
        applied: true,
        [action.payload.filter]: action.payload.value,
      };
      localStorage.setItem("filters", JSON.stringify(filterPersist));
      return {
        ...state,
        filters: {
          ...state.filters,
          applied: true,
          [action.payload.filter]: action.payload.value,
        },
        loading: true,
      };
    case SET_QUERY_FILE:
      localStorage.setItem("queryFile", JSON.stringify(action.payload));
      return {
        ...state,
        queryFile: action.payload,
        /* loading: true, */
      };
    case REMOVE_FILTERS:
      localStorage.removeItem("filters");
      return {
        ...state,
        filters: {
          applied: false,
          filter: "",
          terminal: "",
          visualizeBy: 1,
          dateFrom: "",
          dateTo: "",
          documentType: null,
        },
        loading: true,
        maxPerPage: 10,
      };
    case SET_MAX_PER_PAGE:
      localStorage.setItem("maxPerPage", action.payload);
      return {
        ...state,
        maxPerPage: action.payload,
        loading: true,
      };
    case CLOSE_SESION:
      localStorage.clear();
      return {
        ...state,
        sessionExpired: true,
        loading: false,
      };
    default:
      return state;
  }
};
